import React, { useContext } from 'react';

const DocumentContext = React.createContext(null);

export default DocumentContext;

export function useDocumentContext() {
    return useContext(DocumentContext);
}
